import { atom } from "recoil";

const generalPageLoading = atom({
  key: "generalPageLoading",
  default: true
}) 

export default generalPageLoading;